import { useMemo } from "react";
import useAuth from "components/modules/Auth/useAuth";
import { toast } from "@/client/hooks/use-toast";
import { translateFunc } from "@/utils/translateFunc";
import { useAuthRouter } from "@/modules/Auth/hooks/useAuthRouter";
import { useTranslatedRoute } from "@/hooks/utils/useTranslatedRoute";
import { useIsMobile } from "@/client/hooks/use-mobile";
import { RouteNames } from "@/RouteNames";

export type AccountNavigation = {
    titleKey: string;
    url: string;
    onClick: () => void;
};

export const useAccountNavigation = () => {
    const getTranslatedUrl = useTranslatedRoute();
    const authRouter = useAuthRouter();
    const { logout } = useAuth();
    const isMobile = useIsMobile();
    const errMsg = translateFunc("common:you-have-successfully-logged-out");
    const navLinks = useMemo(() => {
        let navLinks: AccountNavigation[] = [
            {
                titleKey: "common:dashboard",
                url: getTranslatedUrl(RouteNames.dashboardRoute),
                onClick: () => {
                    authRouter.push(RouteNames.dashboardRoute);
                },
            },
            {
                titleKey: "common:logout",
                url: getTranslatedUrl(RouteNames.loginRoute),
                onClick: () => {
                    logout();
                    authRouter.replace(RouteNames.loginRoute);
                    toast({
                        title: errMsg,
                        variant: "success",
                    });
                },
            },
        ];

        if (isMobile) {
            navLinks.splice(navLinks.length - 1, 0, {
                titleKey: "common:change-password",
                url: getTranslatedUrl(RouteNames.changePasswordRoute),
                onClick: () => {
                    authRouter.replace(RouteNames.changePasswordRoute);
                },
            });
        }

        return navLinks;
    }, [isMobile]);

    return { navLinks };
};
